import React from "react"
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { OrderCategory, TApiOrderDetails } from "../../../../api/endpoints/Order";
import { productDailyVolume } from "../../../../utils/Cost";

interface IProps {
  order: TApiOrderDetails<OrderCategory.EU_CUTOUT>;
  epuFootnoteRef?: string;
}

const EuCutOutProductCost = (props: IProps) => {
  const { order, epuFootnoteRef } = props;

  const productCost = order.cost.data.per_product?.[0]; // there's max one product

  if (!productCost) {
    return null;
  }

  return (
    <div className="eu-cut-out-product-cost">
      <Row>
        <Col sm={12} md={10}>
          Total daily volume
        </Col>
        <Col sm={12} md={2}>
          <strong>
            {productDailyVolume(productCost)}
          </strong>
        </Col>
      </Row>
    </div>
  )
}

export default EuCutOutProductCost;

